<div class="outer" *ngIf="lang.languages.length">
    <!-- Success -->
    <div class="section" [style]="1026 | customStyle : db.stylePipeHelper">{{ 265 | l : lang.ph }}</div>
</div>
